import React from "react"
import PropTypes from "prop-types"
import {
    StyledToggleButton,
    StyledToggleButtonGroup,
} from "./ToggleButtonSelect.styled"

const ToggleButtonSelect = ({
    disabled = false,
    leftLabel,
    name,
    onChange,
    rightLabel,
    value = false,
}) => {
    const handleChange = (event, selectedValue) => {
        if (selectedValue !== null) {
            onChange?.(selectedValue === "right")
        }
    }

    return (
        <StyledToggleButtonGroup
            exclusive
            disabled={disabled}
            value={value ? "right" : "left"}
            onChange={handleChange}
            aria-label={`${leftLabel} ou ${rightLabel}`}
        >
            <StyledToggleButton
                value="left"
                name={name}
                aria-label={leftLabel}
            >
                {leftLabel}
            </StyledToggleButton>
            <StyledToggleButton
                value="right"
                name={name}
                aria-label={rightLabel}
            >
                {rightLabel}
            </StyledToggleButton>
        </StyledToggleButtonGroup>
    )
}

ToggleButtonSelect.propTypes = {
    disabled: PropTypes.bool,
    leftLabel: PropTypes.string.isRequired,
    name: PropTypes.string,
    onChange: PropTypes.func,
    rightLabel: PropTypes.string.isRequired,
    value: PropTypes.bool,
}

export default ToggleButtonSelect
